import { makeResource, mapped } from '@codium/codium-vue'
import { http } from '@/utils'
import { storeModule as brightnessLogs } from './screens/brightness-logs'
import { storeModule as mediaOwnerScreenTagOptions } from './screens/media-owner-screen-tags'
import { storeModule as faults } from './screens/faults'
import { storeModule as statusLogs } from './screens/status-logs'
import { storeModule as images } from './screens/images'
import { storeModule as consumptionLogs } from './screens/consumption-logs'
import { storeModule as logs } from './screens/logs'
import { storeModule as cameras } from './screens/cameras'

export const { storeModule, helperComputed, helperMethods, stateMapper } = makeResource('screens', {
  storeModule: {
    modules: {
      brightnessLogs,
      mediaOwnerScreenTagOptions,
      faults,
      statusLogs,
      images,
      consumptionLogs,
      logs,
      cameras
    },

    actions: {
      async restoreScreen ({ getters }, item) {
        await http.put(`${getters.uri()}/${item.id}/restore`, item)
      }
    },
  },

  resource () {
    return {
      id: mapped(null),
      name: mapped(null),
      address: mapped(null),
      longitude: mapped(null),
      latitude: mapped(null),
      status: mapped(null),
      has_camera: mapped(null),
      channel: mapped(null),
      auto_brightness_enabled: mapped(null),
      brightness: mapped(null),
      max_brightness: mapped(null),
      is_manual: mapped(false),
      environment_brightness: mapped(null),
      tags: mapped(null),
      media_owner_tags: mapped(null),
      media_owner_ids: mapped([]),
      media_owner_screen_tags: mapped(null),
      has_backup_power_supplies: mapped(false),
      start_time: mapped(null),
      end_time: mapped(null),
      panel_id: mapped(null),
      timezone: mapped(null),
      device_id: mapped(null),
      install_date: mapped(null),
      screen_size: mapped(null),
      native_resolution: mapped(null),
      canvas_size: mapped(null),
      panel_type: mapped(null),
      pixel_pitch: mapped(null),
      parts_warranty_expiration: mapped(null),
      total_psu: mapped(null),
      total_receiving_card: mapped(null),
      total_qty_module: mapped(null),
      screen_width: mapped(null),
      screen_height: mapped(null),
      service_type: mapped(null),
      psu_type: mapped(null),
      diode_type: mapped(null),
      screen_id: mapped(null),
      energy_provider: mapped(null),
      nmi: mapped(null),
      attachments: mapped([]),
    }
  }
})
